// extracted by mini-css-extract-plugin
module.exports = {"container":"Message_container__2XijW","title":"Message_title__31VMk","description":"Message_description__1Jdmz","actionLink":"Message_actionLink__3FZt_"};